<template>
    <div>
        <el-button type="success" class="apply-soft" @click="apply"
            >申请试用</el-button
        >
        <el-dialog
            title="申请试用"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            custom-class="singleDialog"
        >
            <el-form
                label-width="90px"
                :rules="rules"
                :model="myForm"
                style="margin-left: -15px"
                ref="form"
            >
                <el-form-item label="产品" prop="F_ProductId">
                    <el-select
                        v-model="myForm.F_ProductId"
                        placeholder="请选择"
                        class="width100"
                    >
                        <el-option
                            v-for="item in ProductList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司" prop="F_CorporateName">
                    <el-input
                        v-model="myForm.F_CorporateName"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="F_Name">
                    <el-input v-model="myForm.F_Name" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="F_Phone">
                    <el-input
                        v-model="myForm.F_Phone"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="F_Email">
                    <el-input
                        v-model="myForm.F_Email"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item label="意向说明" prop="F_StatementIntent">
                    <el-input
                        type="textarea"
                        v-model="myForm.F_StatementIntent"
                        maxlength="200"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="submitData"
                    :loading="isLoading"
                    >确定</el-button
                >
                <el-button @click="cancel">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import validator from '../../../../../validator'
import { getSelect, saveData } from '../../../../../service/secondHttp.js'
export default {
    data() {
        return {
            dialogVisible: false,
            myForm: {},
            ProductList: [],
            rules: {
                F_ProductId: [
                    { required: true, message: '请选择产品', trigger: 'blur' },
                ],
                F_CorporateName: [
                    { required: true, message: '请输入公司', trigger: 'blur' },
                ],
                F_Name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                F_Phone: validator.phoneValidator,
                F_Email: validator.emailValidator,
                F_StatementIntent: [
                    { required: true, message: '请输入意向说明', trigger: 'blur' },
                ],
            },
            isLoading: false,
        }
    },
    methods: {
        apply() {
            this.dialogVisible = true
        },
        getProductList() {
            getSelect('Product', this)
        },
        submitData() {
            saveData('UserExperience', this)
        },
        cancel() {
            this.$refs.form.resetFields()
            this.dialogVisible = false
        },
    },
    mounted() {
        this.getProductList()
    },
}
</script>

<style scoped lang="less">
.apply-soft {
    position: absolute;
    right: 0px;
    top: 10px;
}
</style>
